module.exports = __webpack_public_path__ + "static/NSP-logo1-b340128d09a5a60903f08813a0373988.jpg";